import getSelectedTeamsCalendarsService from '../services/getSelectedTeamsCalendarsService';
import {
    addToCalendarsCache,
    addCalendarGroupToCalendarsCache,
    Calendar,
    CalendarGroupExtended,
} from 'owa-calendar-cache';

export interface TeamsCalendars {
    group: CalendarGroupExtended;
    calendars: Calendar[];
}

export async function getSelectedTeamsCalendars() {
    const result = await getSelectedTeamsCalendarsService();
    // add the calendar entries and groups to the cache mappings to keep them up to date
    if (result != null && result.groupCalendars != null) {
        result.groupCalendars.forEach(groupCalendarResult => {
            addToCalendarsCache(
                groupCalendarResult.entry,
                groupCalendarResult.folder,
                groupCalendarResult.mailboxInfo
            );
        });

        addCalendarGroupToCalendarsCache(result.calendarGroup);
    }
}
